/* tslint:disable */
export class Utilities {
    public static parseQueryString(queryString): any {
        let vars = [], hash;
        const hashes = queryString.split("&");
        for (let i = 0; i < hashes.length; i++) {
            hash = hashes[i].split("=");
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    public static getQueryParameter(variable, defaultValue): string {
        const query = window.location.search.substring(1);
        const vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split("=");
            if (decodeURIComponent(pair[0]) === variable) {
                return decodeURIComponent(pair[1]);
            }
        }
        return defaultValue;
    }

    /**
     * Simply compares two string version values.
     * 
     * Example:
     * versionCompare('1.1', '1.2') => -1
     * versionCompare('1.1', '1.1') =>  0
     * versionCompare('1.2', '1.1') =>  1
     * versionCompare('2.23.3', '2.22.3') => 1
     * 
     * Returns:
     * -1 = left is LOWER than right
     *  0 = they are equal
     *  1 = left is GREATER = right is LOWER
     *  And FALSE if one of input versions are not valid
     *
     * @function
     * @param {String} left  Version #1
     * @param {String} right Version #2
     * @return {Integer|Boolean}
     * @author Alexey Bass (albass)
     * @since 2011-07-14
     */
    public static VersionCompare(left: string, right: string) {
        if (typeof left + typeof right != 'stringstring')
            return false;
        
        var a = left.split('.')
        ,   b = right.split('.')
        ,   i = 0, len = Math.max(a.length, b.length);
            
        for (; i < len; i++) {
            if ((a[i] && !b[i] && parseInt(a[i]) > 0) || (parseInt(a[i]) > parseInt(b[i]))) {
                return 1;
            } else if ((b[i] && !a[i] && parseInt(b[i]) > 0) || (parseInt(a[i]) < parseInt(b[i]))) {
                return -1;
            }
        }
        
        return 0;
    }
}

if (!(<any>Date).prototype.asFriendlyString) {
        (function () {
            function pad(number) {
                if (number < 10) {
                    return '0' + number;
                }
                return number;
            }

            (<any>Date).prototype.asFriendlyString = function () {
                return this.getUTCFullYear() +
                    "-"+pad(this.getUTCMonth() + 1) +
                    "-" + pad(this.getUTCDate());
            };

        }());
}


// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/utilities.ts